<!-- <div class="top-menu"> -->
    <zq-tab-group [emptyDefault]="true" [currentTabLabel]="'zoning-codes'">
        <zq-tab label="zoning-codes" name="Zoning Codes" [templateRef]="importZoningCodes">
            <ng-template #importZoningCodes>
                <app-zoning-codes-import-table></app-zoning-codes-import-table>
            </ng-template>
        </zq-tab>
    </zq-tab-group>
<!-- </div> -->
